import { ref, reactive, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-55313f51"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "promotion-code-add"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "section"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 创建推广码 ")], -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  style: {
    "color": "rgba(0, 0, 0, 0.45)"
  }
}, "可包含数字、字母，ID一经创建便无法再重复使用", -1));
const _hoisted_6 = {
  class: "section"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 选择推广商品 ")], -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  style: {
    "color": "rgba(0, 0, 0, 0.45)"
  }
}, "目前仅支持非消耗型商品推广", -1));
const _hoisted_9 = {
  class: "footer-buttons"
};
const __default__ = {
  name: 'promotionCodeAdd'
};
import { useRouter, useRoute } from 'vue-router';
import { LeftOutlined } from '@ant-design/icons-vue';
import dayjs from 'dayjs';
import { message } from 'ant-design-vue';
import { savePromotion, updatePromotion, queryPromotionDetail, queryCanPromotionProdList } from '@/api/promotionApi';
import { filterOption } from '@/common';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const formRef = ref();
    const isEdit = ref(false);
    // 添加商品列数据
    const productOptions = ref([]);
    const originalProductList = ref([]);
    // 表单数据
    const formData = reactive({
      id: '',
      dbtId: '',
      promotionName: '',
      promotionCode: '',
      validTo: null,
      continueCreate: false,
      productType: 'ios',
      productId: undefined,
      productName: '',
      price: ''
    });
    // 商品选择变化处理函数
    const handleProductChange = value => {
      if (!value) {
        return;
      }
      const selectedProduct = productOptions.value.find(item => item.value === value);
      if (selectedProduct) {
        formData.productName = selectedProduct.name;
        // 从存储的原始数据中获取价格
        const originalProduct = originalProductList.value.find(item => item.prodPkId == value);
        formData.price = `${originalProduct === null || originalProduct === void 0 ? void 0 : originalProduct.price} ${originalProduct === null || originalProduct === void 0 ? void 0 : originalProduct.currency}` || '';
      } else {
        formData.productName = '';
        formData.price = '';
      }
    };
    // 表单校验规则
    const rules = {
      promotionName: [{
        required: true,
        message: '请输入推广码名称',
        trigger: 'blur'
      }, {
        min: 1,
        max: 50,
        message: '推广码名称长度为1-50个字符',
        trigger: 'blur'
      }, {
        pattern: /^[\u4e00-\u9fa5a-zA-Z0-9\s]+$/,
        message: '仅支持中文、字母、数字、空格',
        trigger: 'change'
      }],
      promotionCode: [{
        required: true,
        message: '请输入推广码ID',
        trigger: 'blur'
      }, {
        min: 1,
        max: 100,
        message: '推广码ID长度为1-100个字符',
        trigger: 'blur'
      }, {
        pattern: /^[a-zA-Z0-9]+$/,
        message: '仅支持数字、大小写字母',
        trigger: 'change'
      }],
      validTo: [{
        required: true,
        message: '选择失效日期',
        trigger: 'change'
      }],
      productId: [{
        required: true,
        message: '请选择商品',
        trigger: 'submit'
      }]
    };
    // 限制promotionId输入
    const handlePromotionIdInput = e => {
      const input = e.target;
      formData.promotionCode = input.value.replace(/[^a-zA-Z0-9]/g, '');
    };
    // 提交表单
    const handleSubmit = () => {
      var _formRef$value;
      (_formRef$value = formRef.value) === null || _formRef$value === void 0 || _formRef$value.validate().then(async () => {
        try {
          const submitData = {
            id: formData.id,
            dbtId: formData.dbtId,
            prodPkIds: [formData.productId],
            promotionName: formData.promotionName,
            promotionCode: formData.promotionCode,
            validTo: dayjs(formData.validTo).endOf('day').format('YYYY-MM-DD HH:mm:ss')
          };
          const response = formData.id ? await updatePromotion(submitData) : await savePromotion(submitData);
          if (response.code === '0') {
            message.success('保存成功');
            if (!formData.continueCreate) {
              router.push('/promotionCodeList');
            } else {
              var _formRef$value2;
              // 保留推广商品渠道和推广商品ID信息
              const productType = formData.productType;
              const productId = formData.productId || undefined;
              // 重置表单
              (_formRef$value2 = formRef.value) === null || _formRef$value2 === void 0 || _formRef$value2.resetFields();
              formData.productType = productType;
              formData.productId = productId;
              // 发商品选择变化处理
              if (productId) {
                handleProductChange(productId);
              }
            }
          }
        } catch (error) {
          message.error('操作失，请重试');
        }
      });
    };
    // 取消
    const handleCancel = () => {
      router.back();
    };
    // 禁用当前日期之前的日期
    const disabledDate = current => {
      return current && current < dayjs().startOf('day');
    };
    // 获取推广码详情
    const fetchPromotionDetail = async id => {
      try {
        const response = await queryPromotionDetail({
          id
        });
        if (response.code === '0') {
          // 表单赋值
          const detail = response.data;
          formData.id = detail.id;
          formData.dbtId = detail.dbtId;
          formData.promotionName = detail.promotionName;
          formData.promotionCode = detail.promotionCode;
          formData.validTo = dayjs(detail.validTo);
          // 处理商品信息
          if (detail.promotionProductList && detail.promotionProductList.length > 0) {
            var _detail$promotionProd;
            // 转换数据格式
            productOptions.value = (_detail$promotionProd = detail.promotionProductList) === null || _detail$promotionProd === void 0 ? void 0 : _detail$promotionProd.map(item => ({
              label: item.prodId,
              value: item.prodPkId,
              name: item.prodName
            }));
            const product = detail.promotionProductList[0];
            formData.productType = product.chnlFlag === 'google' ? 'android' : 'ios';
            formData.productId = product.prodPkId;
            formData.productName = product.prodName;
            formData.price = `${product.price} ${product.currency}`;
          }
        } else {
          message.error(response.msg || '获取详情失败');
        }
      } catch (error) {
        message.error('获取详情失败，请重试');
      }
    };
    const getPromotionProdList = async dbtId => {
      try {
        const res = await queryCanPromotionProdList({
          dbtId
        });
        if (res.code === '0') {
          originalProductList.value = res.data;
          // 转换数据格式
          productOptions.value = res.data.map(item => ({
            label: item.prodId,
            value: item.prodPkId,
            name: item.prodName
          }));
        } else {
          message.error(res.msg);
        }
      } catch (error) {
        message.error('获取可推广商��列表失败');
      }
    };
    onMounted(async () => {
      var _route$query, _route$query2, _route$query3;
      formData.dbtId = (_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.dbtId;
      formData.id = (_route$query2 = route.query) === null || _route$query2 === void 0 ? void 0 : _route$query2.id;
      isEdit.value = !!((_route$query3 = route.query) !== null && _route$query3 !== void 0 && _route$query3.id);
      // 获取可推广商品列表
      if (formData.dbtId) {
        await getPromotionProdList(formData.dbtId);
      }
      // 如果有id，获取详情数据
      if (formData.id) {
        await fetchPromotionDetail(formData.id);
      }
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_date_picker = _resolveComponent("a-date-picker");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_space = _resolveComponent("a-space");
      const _component_a_card = _resolveComponent("a-card");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_button, {
        type: "link",
        class: "back-btn",
        onClick: handleCancel
      }, {
        icon: _withCtx(() => [_createVNode(_unref(LeftOutlined))]),
        default: _withCtx(() => [_createTextVNode(" 返回 ")]),
        _: 1
      })]), _createVNode(_component_a_card, {
        class: "content",
        bodyStyle: {
          height: 'calc(100% - 57px)'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formData,
          rules: rules,
          "wrapper-col": {
            span: 8
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_a_form_item, {
            label: "推广码名称",
            name: "promotionName"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formData.promotionName,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => formData.promotionName = $event),
              valueModifiers: {
                trim: true
              },
              placeholder: "请输入"
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "推广码ID",
            name: "promotionCode"
          }, {
            extra: _withCtx(() => [_hoisted_5]),
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formData.promotionCode,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => formData.promotionCode = $event),
              placeholder: "请输入",
              onInput: handlePromotionIdInput,
              disabled: isEdit.value
            }, null, 8, ["value", "disabled"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "过期时间",
            name: "validTo"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_date_picker, {
              value: formData.validTo,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => formData.validTo = $event),
              "disabled-date": disabledDate,
              style: {
                "width": "100%"
              }
            }, null, 8, ["value"])]),
            _: 1
          })]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_a_form_item, {
            label: "推广商品ID",
            name: "productId"
          }, {
            extra: _withCtx(() => [_hoisted_8]),
            default: _withCtx(() => [_createVNode(_component_a_select, {
              value: formData.productId,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => formData.productId = $event),
              placeholder: "请选择",
              onChange: handleProductChange,
              disabled: isEdit.value,
              options: productOptions.value,
              "show-search": "",
              "filter-option": _unref(filterOption)
            }, null, 8, ["value", "disabled", "options", "filter-option"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "商品名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formData.productName,
              "onUpdate:value": _cache[4] || (_cache[4] = $event => formData.productName = $event),
              disabled: "",
              placeholder: "选择商品后自动回显"
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "默认价格"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formData.price,
              "onUpdate:value": _cache[5] || (_cache[5] = $event => formData.price = $event),
              disabled: "",
              placeholder: "选择商品后自动回显"
            }, null, 8, ["value"])]),
            _: 1
          })])]),
          _: 1
        }, 8, ["model"]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_a_space, null, {
          default: _withCtx(() => [_createVNode(_component_a_button, {
            onClick: handleCancel
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), _createVNode(_component_a_button, {
            type: "primary",
            onClick: handleSubmit
          }, {
            default: _withCtx(() => [_createTextVNode("保存")]),
            _: 1
          }), _createVNode(_component_a_checkbox, {
            checked: formData.continueCreate,
            "onUpdate:checked": _cache[6] || (_cache[6] = $event => formData.continueCreate = $event)
          }, {
            default: _withCtx(() => [_createTextVNode("连续创建")]),
            _: 1
          }, 8, ["checked"])]),
          _: 1
        })])]),
        _: 1
      }, 8, ["bodyStyle"])]);
    };
  }
});